import { Box, Grid, Paper, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import { Autocomplete, Button, DatePicker, Select, TextField } from 'components/AORedesign';
import { filterOptions, getOptionLabel } from '../../../CommonUtilityServices/EventHandlerService';

import { autocompleteInputValues, menuItemsTypes } from './PaymentHistory.types';

const PaymentHistoryFilter = ({
  autocompleteInputValues,
  formData,
  handleOnBlurAutocomplete,
  handleOnChange,
  handleOnChangeAutocomplete,
  handleOnChangeFromDate,
  handleOnChangeToDate,
  handleOnClickFilterResults,
  handleOnClickResetFilters,
  handleOnInputChangeAutocomplete,
  menuItems,
}) => {
  return (
    <Paper variant="outlined" square>
      <Box p={2}>
        <Box mb={2}>
          <Typography>Use Selections to filter the payment management history</Typography>
        </Box>
        <Box mb={4}>
          <Grid container spacing={2}>
            <Grid item>
              <Select
                label="Admin"
                id="payment-history-admin-dd"
                menuItems={menuItems.adminList.map((e) => ({ value: e, label: e }))}
                name="admin"
                value={formData.admin}
                onChange={(e) => handleOnChange(e)}
              />
            </Grid>
            <Grid item>
              <Autocomplete
                id="payment-history-agency"
                disableClearable
                filterOptions={filterOptions}
                getOptionLabel={getOptionLabel}
                value={formData.agency}
                inputValue={autocompleteInputValues.agency.value}
                options={menuItems.agencyList ?? []}
                onChange={(e, newValue) => handleOnChangeAutocomplete(e, newValue, 'agency')}
                onInputChange={(e, newValue) => handleOnInputChangeAutocomplete(e, newValue, 'agency')}
                onBlur={() => handleOnBlurAutocomplete('agency')}
                style={{ width: '279px' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Agency"
                    placeholder="Select Agency"
                    error={!!autocompleteInputValues.agency.invalidText}
                    helperText={autocompleteInputValues.agency.invalidText}
                  />
                )}
              />
            </Grid>
            <Grid item>
              <DatePicker
                id={`payment-history-from-datepicker`}
                name={`paymentHistoryFromDate`}
                label={`Date Range Start`}
                value={formData.paymentHistoryFromDate}
                onChange={(date) => handleOnChangeFromDate(date)}
              />
            </Grid>
          </Grid>
        </Box>
        <Box mb={4}>
          <Grid container spacing={2}>
            <Grid item>
              <Autocomplete
                id="payment-history-account"
                disableClearable
                filterOptions={filterOptions}
                getOptionLabel={getOptionLabel}
                value={formData.account}
                inputValue={autocompleteInputValues.account.value}
                options={menuItems.accountList ?? []}
                onChange={(e, newValue) => handleOnChangeAutocomplete(e, newValue, 'account')}
                onInputChange={(e, newValue) => handleOnInputChangeAutocomplete(e, newValue, 'account')}
                onBlur={() => handleOnBlurAutocomplete('account')}
                style={{ width: '279px' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Account"
                    placeholder="Select Account"
                    error={!!autocompleteInputValues.account.invalidText}
                    helperText={autocompleteInputValues.account.invalidText}
                  />
                )}
              />
            </Grid>
            <Grid item>
              <Select
                label="Tran Type"
                id="payment-history-tran-type-dd"
                menuItems={menuItems.tranTypeList.map((e) => ({ value: e, label: e }))}
                name="tranType"
                value={formData.tranType}
                onChange={(e) => handleOnChange(e)}
              />
            </Grid>
            <Grid item>
              <DatePicker
                id={`payment-history-to-datepicker`}
                name={`paymentHistoryToDate`}
                label={`Date Range End`}
                value={formData.paymentHistoryToDate}
                onChange={(date) => handleOnChangeToDate(date)}
              />
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Box display="flex" justifyContent="flex-start">
            <Box mr={2}>
              <Button variant="contained" color="primary" onClick={handleOnClickFilterResults}>
                Filter
              </Button>
            </Box>
            <Box mx={2}>
              <Button variant="contained" onClick={handleOnClickResetFilters} color="default">
                Reset
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

PaymentHistoryFilter.propTypes = {
  autocompleteInputValues: PropTypes.shape({
    account: autocompleteInputValues,
    agency: autocompleteInputValues,
  }),
  formData: PropTypes.shape({
    account: PropTypes.string,
    admin: PropTypes.string,
    agency: PropTypes.string,
    paymentHistoryFromDate: PropTypes.string,
    paymentHistoryToDate: PropTypes.string,
    tranType: PropTypes.string,
  }),
  handleOnBlurAutocomplete: PropTypes.func,
  handleOnChange: PropTypes.func,
  handleOnChangeAutocomplete: PropTypes.func,
  handleOnChangeFromDate: PropTypes.func,
  handleOnChangeToDate: PropTypes.func,
  handleOnClickFilterResults: PropTypes.func,
  handleOnClickResetFilters: PropTypes.func,
  handleOnInputChangeAutocomplete: PropTypes.func,
  menuItems: PropTypes.shape({
    accountList: menuItemsTypes,
    adminList: menuItemsTypes,
    agencyList: menuItemsTypes,
    tranTypeList: menuItemsTypes,
  }),
};

export default PaymentHistoryFilter;
